import React, { useContext, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { IntegrationContext, IntegrationContextPayload } from '../../../context/integrationContext';
import FacebookInformationCard from '../../utility/facebookInformationCard';
import GlobalDeletePopup from '../../utility/globalDeletePopup/globalDeletePopup';
import { UserContext, UserContextPayload } from '../../../context/userContext';
import agent from '../../../services/api';
import { useGenericStore } from '../../../store/genericStore';
import { useShallow } from 'zustand/react/shallow';
// import FacebookInformationCard from '../../utils/FacebookInformationCard';

interface checkFlag {
    flagPage?: boolean
}

function FacebookIntegationDetails(props: checkFlag) {
    const navigate = useNavigate()
    const { facebookIntegrationDetails } = useContext(IntegrationContext) as IntegrationContextPayload
    const { setFlagLoading, handleError } = useContext(UserContext) as UserContextPayload;
    const [showDeleteConfirmation, setShowDeleteConfirmation] = useState<boolean>(false);

    const { showSuccess } = useGenericStore(useShallow((state) => ({
        showSuccess: state.showSuccess
    })))

    const deleteMetaIntegration = async () => { 
        if(facebookIntegrationDetails){
            setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: true }))
            const payload = {
                channel_id: facebookIntegrationDetails.channel_id, 
                integrated_channel_id: facebookIntegrationDetails.integrated_channel_id
            }
            const response = await agent.deleteMetaIntegration.delete(payload);
            if (response.status) {
                showSuccess("Integration deleted Successfully!")
                navigate('/channels')
            } else {
                handleError(response);
            }
            setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: false }))
        }
    }
    return (
        <>
            {facebookIntegrationDetails !== null &&
                <FacebookInformationCard
                    integrationType="Facebook"
                    key={facebookIntegrationDetails.integrated_channel_id}
                    flagDelete={true}
                    title={"Meta"}
                    flagShowMetaIcon={true}
                    currentlySelected={false}
                    details={{
                        integrated_channel_id: ""
                    }}
                    deleteChatbotIntegration={() => {
                        setShowDeleteConfirmation(true)
                    }
                    }
                />
            }
            {facebookIntegrationDetails !== null &&
                <>
                    <FacebookInformationCard
                        integrationType="Facebook"
                        key={1}
                        flagDelete={false}
                        title={`Facebook Account ${1}`}
                        currentlySelected={facebookIntegrationDetails.chatbot_integration_assignment_data.length > 0}
                        details={{
                            page_id: ("page_id" in facebookIntegrationDetails) ? facebookIntegrationDetails.page_id : "",
                            integrated_channel_id: String(facebookIntegrationDetails?.integrated_channel_id) || "",
                            page_name: ("page_name" in facebookIntegrationDetails) ? facebookIntegrationDetails.page_name : "",
                            page_category: ("page_category" in facebookIntegrationDetails) ? facebookIntegrationDetails.page_category : "",
                            linked_chatbots: facebookIntegrationDetails.chatbot_integration_assignment_data
                        }}

                    />
                </>
            }

            {showDeleteConfirmation &&
                <GlobalDeletePopup
                    deleteDescription={`Are you sure you want to delete this Integration`}
                    open={showDeleteConfirmation}
                    onClose={() => { setShowDeleteConfirmation(false) }}
                    onDelete={() => {
                        deleteMetaIntegration()
                        setShowDeleteConfirmation(false)
                    }}
                />
            }

        </>

    )
}

export default FacebookIntegationDetails